import { render, staticRenderFns } from "./ButtonReportStatements.vue?vue&type=template&id=8816e012"
import script from "./ButtonReportStatements.vue?vue&type=script&lang=js"
export * from "./ButtonReportStatements.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports